<template>
  <a-modal title='添加成员' v-model="show" @cancel="handleCancel" :width='900' @ok='handleConfirm' :okText="'确定（'+checkedLeafNodes.length+'）'">
   <div class="sub-title">
     <div>按照部门添加：</div>
     <div>成员：</div>
   </div>
    <div class='tree-container'>
      
      <div class='tree'>
        <a-input class='search-input' v-model="searchText" placeholder='输入检索' @change="onChange"></a-input>
        <a-tree class='search-tree'  checkable :tree-data="showData" @check='handleCheck' v-model="checkedNode"
           :expanded-keys="expandedKeys"   @expand="onExpand" :autoExpandParent='autoExpandParent'>
          <template slot="title" slot-scope="{ title }">
            <span v-if="title.indexOf(searchText) > -1" >
              {{ title.substr(0, title.indexOf(searchText)) }}
              <span style="color: #f50">{{ searchText }}</span>
              {{ title.substr(title.indexOf(searchText) + searchText.length) }}
            </span>
          
            <span v-else>{{ title }}</span>
          </template>
        </a-tree>
      </div>
      <div class='checked'>
  
        <div class="checked-tags">
          <a-tag v-for="item in checkedLeafNodes" :key="item.key"> {{item.title}}</a-tag>
        </div>
      </div>

    </div>
  </a-modal>
</template>

<script>
import ProjectManageService from '../../services/ProjectManageService';
import {
  debounce,
  cloneDeep
} from 'lodash';
let dataList = []
const getParentKey = (key, tree) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: [Number, String],
      required: true
    }
  },
  model: {
    prop: 'value',
    event: 'handleShow'
  },
  watch: {
    value() {
     
      this.show = this.value;
       this.show &&  this.getTree()
      this.searchText=''
      this.checkedNode=[]
      this.checkedLeafNodes=[]
      this.expandedKeys=[]
 
    }
  },
  data() {
    return {
      autoExpandParent: false,
      show: false,
      staffTree: [],
      checkedNode: [],
      checkedLeafNodes: [],
      expandedKeys: [],
      showData: [],
      treeData: [],
      searchText: ''
    }
  },
  methods: {
    handleConfirm() {
      const params = {
        staff_uids: this.checkedNode.filter(node => typeof node === 'number') //数字类型代表叶子节点
      }
      this.$emit('submit', params)


    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    clear() {
      this.checkedNode = []
      this.checkedLeafNodes = []
    },
    handleCheck(keys, e) {
      console.log(e);
      this.checkedLeafNodes = e.checkedNodes
        .filter(node => {
          return node.componentOptions.propsData.isLeaf
        }).map(node => node.data.props.dataRef)

      // console.log(this.checkedLeafNodes);
    },

    exchangeStaffTree(staffTree) {
      dataList=[]
      const walkStaffTree = (arr, parentPath) => {
        // console.log(arr);
        const res = arr && arr.map(item => {
          const key = item.deptId ? (item.deptId + 'dept') : item.uid
          const path = (parentPath ? (parentPath + '-') : '') + key
          const subList=[...(item
              .subDeptList||[]),...(item.staffList||[])]
          const sub = {
            title: item.deptName || item.name,
            key,
            isLeaf: !!(item.uid),
            path,
            scopedSlots: {
              title: 'title'
            },
            children:  walkStaffTree(subList, path),
          }

          dataList.push(sub)

          return sub
        })
        return res
      }
      return walkStaffTree(staffTree)
    },
    handleCancel() {
      this.$emit('handleShow', false)
      this.clear()
    },
    getTree() {
      const projectId = this.projectId
      ProjectManageService.getStaffTree({
        projectId
      }).then(res => {
        if (res.status === 'success') {
          this.staffTree = res.data
          this.treeData = this.exchangeStaffTree(this.staffTree)
          this.showData = cloneDeep(this.treeData)
        } else {
          // this.$message.error(res.error)
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('网络连接失败')
      })
    },
    addClassOnItem() {
// const mainList=this.treeData.map(tree=>tree.key)


      const walkTree = (expandedKeys, tree, searchText) => {
        // console.log(expandedKeys);
        // const showKeys=expandedKeys
        const res = tree.map(item => {


          if (expandedKeys.includes(item.key) ) {
            console.log(item);
          }
          item.class = (expandedKeys.includes(item.key) || item.title.indexOf(searchText) > -
            1) ? '' : 'hideItem'

          if (item.children && item.children.length) {
            item.children = walkTree(expandedKeys, item.children, searchText)
          }
          return item
        })
        return res
      }
      console.log(this.expandedKeys);
      const res = walkTree(this.expandedKeys, cloneDeep(this.treeData), this.searchText)
  
      this.showData = res
    },
    handeSearch: debounce(function () {
      if (this.searchText) {
    
        const keys = dataList.filter((item) => item && item.title.indexOf(this.searchText) > -1).map((item) =>{
   
          return item.path.split('-')}).flat();
          this.expandedKeys =[... new Set(keys)]
       
        this.autoExpandParent = true;
     
          this.addClassOnItem()
      } else {
        console.log(this.treeData);
        this.showData = cloneDeep(this.treeData)
           this.expandedKeys =[]
      }
    }, 500),
    onChange(e) {

      this.handeSearch.call(this);
    },

  },
  mounted() {
    this.show = this.value;
    this.$emit('handleShow', this.show)

  }
}
</script>

<style lang="less" scoped>
.sub-title{
  display: flex;
  justify-content: space-between;
  >*{
    width:396px
  }
}
.tree-container{
  width:856px;
  display: flex;
  justify-content: space-between;
  
  >div{
    width:400px;
    height:600px;
    border:1px solid #dedede;
    &.tree{
      // position: relative;
      .search-tree{
        height:560px;
        overflow: auto;
      }
    }
  }
   ::v-deep .hideItem{
    display:none
  }

}
.checked{
padding: 6px;  overflow: auto;
  &-tags{
    >*{
      margin-bottom: 6px;
      }
  }
}
</style>